import { Spin } from "antd";
import { Toast } from "antd-mobile";
import axios from "axios";
import { toPng } from "html-to-image";
import React, { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import PsContext from "../../context";
import { getStudentTemplate } from "../../models/utilities";
import {
  bulkReplace,
  getFileLiveUrl,
  momentDate,
  upperCase,
  yearBySem,
} from "../../utils";
import {
  CERTIFICATE_TEMPLATE_NAMES,
  MOB_ICONS,
  VENDOR_LOGO,
} from "../../utils/data";
import { ServiceUrl } from "../../utils/serviceUrl";

import Header from "../header";

const IDCard = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);

  const [selectedCourse, setSelectedCourse] = useState([]);

  const [template, setTemplate] = useState([]);

  const [idCardDataList, setIdCardDataList] = useState([]);

  const [idCardDataView, setIdCardDataView] = useState([]);

  const [selectedFilter, setSelectedFilter] = useState([]);

  useEffect(() => {
    getReport();
    if (context.user && context.user.uuid) loadTemplate();
  }, [context.user]);

  const loadTemplate = () => {
    // alert("hi");
    setLoader(true);
    getStudentTemplate(CERTIFICATE_TEMPLATE_NAMES.STUDENT_IDCARD).then(
      (res) => {
        if (res) setTemplate(res);
        setLoader(false);
      }
    );
  };

  //console.log(template);

  const field = (fieldName) => {
    if (template && template[fieldName]) return template[fieldName];
  };

  const studentField = (i, fieldName) => {
    if (context.user && context.user[fieldName]) return context.user[fieldName];
  };

  const getContent = () => {
    let ar = [];

    ar["{{billheader_name}}"] = context.settingValue("billheader_name") || "";
    ar["{{billheader_city}}"] =
      context.settingValue("billheader_addresscity") || "";
    ar["{{billheader_addresslineone}}"] =
      context.settingValue("billheader_addresslineone") || "";
    ar["{{billheader_addresslinetwo}}"] =
      context.settingValue("billheader_addresslinetwo") || "";
    ar["{{logo_path}}"] = VENDOR_LOGO;
    ar["{{student_name}}"] = upperCase(context.user.name) || "";
    ar["{{student_initial}}"] = upperCase(context.user.initial) || "";
    ar["{{blood_group}}"] = upperCase(context.user.blood_group) || "";
    ar["{{doorno_present}}"] = upperCase(context.user.doorno_present) || "";
    ar["{{street_persent}}"] = upperCase(context.user.street_persent) || "";
    ar["{{village_present}}"] = upperCase(context.user.village_present) || "";
    ar["{{district_present}}"] = upperCase(context.user.district_present) || "";
    ar["{{pincode_present}}"] = upperCase(context.user.pincode_present) || "";
    ar["{{mobile}}"] = upperCase(context.user.mobile) || "";
    ar["{{college_address}}"] =
      context.settingValue("billheader_addresscity") || "";
    ar["{{college_place}}"] =
      context.settingValue("billheader_addresscity") || "";
    ar["{{student_title}}"] =
      upperCase(studentField("gender")) == "MALE" ? "Mr" : "Mrs";
    ar["{{so_or_do}}"] =
      upperCase(studentField("gender")) == "MALE" ? "S/o" : "D/o";
    ar["{{father_name}}"] = upperCase(studentField("fathername")) || "";
    ar["{{degree_name}}"] = upperCase(context.user.degree_name) || "";
    ar["{{year_name}}"] = yearBySem(context.user.semester, true) || "";
    ar["{{course_name}}"] = upperCase(context.user.course_name) || "";
    ar["{{entry_date}}"] =
      momentDate(studentField("created_on"), "DD-MM-YYYY") || "";
    ar["{{stu_dob}}"] = momentDate(context.user.dob) || "";
    ar["{{stu_regno}}"] = upperCase(context.user.registerno) || "";
    ar["{{roll_no}}"] = context.user.rollno || context.user.admissionno || "";
    ar["{{college_year}}"] = context.user.college_year || "";

    ar["{{student_photo}}"] = context.user.profile_photo
      ? getFileLiveUrl(context.user.profile_photo)
      : MOB_ICONS.NO_PHOTO.default;

    console.log(ar);

    let x = bulkReplace(
      field("certificate_content"),
      Object.keys(ar),
      Object.values(ar)
    );

    return x;
  };

  const getReport = () => {
    setLoader(true);
    setIdCardDataList([]);
    setIdCardDataView([]);

    axios
      .get(ServiceUrl.STUDENTS.LIST_STUDENT_CERTIFICATES)

      .then((res) => {
        //console.log(res);
        if (res["data"].status == "1") {
          let d = res["data"].data.filter((certificate) =>
            certificate.certificate_name.includes("student_id_card")
          );
          // console.log(d);

          setIdCardDataList(d);
          setIdCardDataView(d);
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        setLoader(false);
      });
  };

  const handleDownload = () => {
    const content = document.getElementById("print_stu_idcard");

    toPng(content)
      .then(function (dataUrl) {
        const downloadLink = document.createElement("a");
        downloadLink.href = dataUrl;
        downloadLink.download = "Image.png";
        downloadLink.click();
      })
      .catch((error) => {
        console.error("Error converting HTML to image:", error);
      });
  };

  console.log(context.user);

  return (
    <>
      <Header title="ID Card" backAction={true} rightActions={[]} />
      <div className="page-content-wrapper ">
        <br />
        <div className="container">
          <div className="">
            <Spin spinning={loader}>
              {context.user && context.user.uuid && (
                <>
                  <div id="print_stu_idcard">
                    <div
                      className="text-left"
                      style={{
                        height: "30%",
                        width: "300px",
                        margin: "",
                        textAlign: "left",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: getContent(),
                      }}
                    />
                  </div>
                  <div className="text-center mt-4">
                    <Button onClick={handleDownload}>Download</Button>
                  </div>
                </>
              )}
            </Spin>
          </div>
        </div>
      </div>
    </>
  );
};

export default IDCard;
